import React from "react";
import { motion } from "framer-motion";
import { Clock, Users, FileCheck2, ShieldHalf } from "lucide-react";

const points = [
  {
    icon: ShieldHalf,
    title: "Confidential by default",
    body: "Your financial information is handled within the firm. No outsourced data, no third-party processing.",
  },
  {
    icon: Clock,
    title: "On-time, every time",
    body: "Filings, audits and returns are tracked against statutory deadlines well in advance — no last-minute scrambles.",
  },
  {
    icon: Users,
    title: "Partner-led engagements",
    body: "Every assignment is overseen personally by CA Roopesh Kumar. You speak to a Chartered Accountant, not a call centre.",
  },
  {
    icon: FileCheck2,
    title: "Clear, plain advice",
    body: "We translate the Act, the GST law and the Companies Act into language you can act on. No jargon, no fine print.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline mb-5">
              <span className="divider-gold mr-3" /> Why clients return
            </div>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#111814]"
              data-testid="why-heading"
            >
              Diligence is the <em className="italic">discipline</em> we
              practise daily.
            </h2>
            <p className="mt-6 text-[#3A453F] text-base md:text-lg leading-relaxed max-w-md">
              The same principles guide a routine GST return and a year-end
              statutory audit. Care, accuracy, and the willingness to question
              what does not look right.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {points.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  className="border-t border-[#E5E1D8] pt-8"
                  data-testid={`why-point-${i + 1}`}
                >
                  <Icon size={22} strokeWidth={1.4} className="text-[#C5A059]" />
                  <h3 className="font-serif text-2xl md:text-3xl text-[#111814] mt-5 leading-tight">
                    {p.title}
                  </h3>
                  <p className="text-[#3A453F] text-[15px] leading-relaxed mt-3">
                    {p.body}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
